import React, { useState, useEffect } from 'react';
import { SystemNotification } from '@monavate/ui-core';
import { RootState, useAppDispatch, useAppSelector } from '../../reduxStore/rootReducer';
import { clearNotifications } from '../../reduxStore/slices/systemNotificationSlice';

enum EStatuses {
    success = 'success',
    info = 'info',
    warning = 'warning',
    error = 'error',
    failure = 'failure',
}

const SystemNotificationController = () => {
    const dispatch = useAppDispatch();
    const [message, setMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [status, setStatus] = useState(EStatuses.success);
    const [closeTimeout, setCloseTimeout] = useState(5000);
    const notification = useAppSelector(
        (state: RootState) => state.systemNotification.notification,
    );

    useEffect(() => {
        if (notification) {
            const { message, status, closeTimeout } = notification;
            setMessage(message);
            setStatus(EStatuses[status]);
            if (closeTimeout) {
                setCloseTimeout(closeTimeout);
            }
            setIsOpen(true);
            dispatch(clearNotifications());
        }
    }, [notification]);

    const onHandleCloseCallback = () => {
        setIsOpen(false);
        setMessage('');
        setStatus(EStatuses.success);
        setCloseTimeout(5000);
    };
    return (
        <SystemNotification
            message={message}
            open={isOpen}
            handleClose={onHandleCloseCallback}
            status={status}
            closeTimeout={closeTimeout}
        />
    );
};

export default SystemNotificationController;
